import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CalendarIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-10 relative overflow-hidden" data-id="element-55">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-56">
        <FadeIn data-id="element-57">
          <div className="bg-gradient-to-br from-primary/10 via-card to-background border border-primary/20 rounded-3xl p-6 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-58">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl pointer-events-none" data-id="element-59" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/10 rounded-full blur-3xl pointer-events-none" data-id="element-60" />

            <div className="text-center mb-8 relative z-10" data-id="element-61">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 text-primary mb-6" data-id="element-62">
                <CalendarIcon className="w-8 h-8" data-id="element-63" />
              </div>
              <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-64">
                Lo que cambia en 7 días
              </h2>
              <p className="text-xl text-primary font-medium" data-id="element-65">
                Prueba de Credibilidad
              </p>
            </div>

            <div className="space-y-6 relative z-10" data-id="element-66">
              <div className="flex items-start gap-5 bg-background/50 p-5 rounded-2xl border border-card-border" data-id="element-67">
                <TrendingUpIcon className="w-8 h-8 text-green-500 shrink-0 mt-1" data-id="element-68" />
                <div data-id="element-69">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-70">
                    Estructura Inmediata
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-71">
                    En la primera semana de usar la Base Técnica, vas a notar
                    cómo tus clases ganan estructura.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5 bg-background/50 p-5 rounded-2xl border border-card-border" data-id="element-72">
                <ShieldCheckIcon className="w-8 h-8 text-primary shrink-0 mt-1" data-id="element-73" />
                <div data-id="element-74">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-75">
                    Confianza Total
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-76">
                    Tus alumnos empiezan a confiar más en cada elección. Y vos
                    sentís la tranquilidad de tener una respuesta profesional
                    inmediata.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}